import { render, staticRenderFns } from "./addStaff.vue?vue&type=template&id=07d6ae51"
import script from "./addStaff.vue?vue&type=script&lang=js"
export * from "./addStaff.vue?vue&type=script&lang=js"
import style0 from "./addStaff.vue?vue&type=style&index=0&id=07d6ae51&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports